module.exports = __webpack_public_path__ + "static/media/kiendoan.aab08687.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/kiendoan.jpeg
// module id = 131
// module chunks = 0